import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import qs from 'qs';

import { useRootDispatch } from '../../../../../store/hooks';
import { useVIPCodeCookie } from '../useVIPCodeCookie';
import { fetchSitePricingCheckVIPCode } from '../../../store/features/discounts';

export function useCheckVIPCode() {
  const { search, pathname } = useLocation();
  const dispatch = useRootDispatch();
  const { setVIPCodeCookie } = useVIPCodeCookie();

  const queryParams = qs.parse(search.replace(/\?/, ''));
  const { vip_code } = queryParams;

  useEffect(() => {
    if (vip_code && !pathname.includes('purchase')) {
      setVIPCodeCookie(vip_code as string);
      dispatch(fetchSitePricingCheckVIPCode({ code: vip_code as string }));
    }
    // eslint-disable-next-line
  }, []);
}
